import Util from '@/helper/Utility';
export class PaymentQrModel {
    constructor() {
        this.success = false
        this.expireTimeSecond = 600
        this.imageQr = null
        this.qrId = null
    }

    setDataFromApi(data) {
        this.success = data.success
        this.expireTimeSecond = data.expire_time_seconds
        this.imageQr = data.image_with_base64
        this.qrId = data.qrId
    }
}
export class PaymentQRCodeSocketModel {
    constructor() {
        this.referenceQrId = null;
        this.sourceId = null;
        this.sourceName = null;
        this.sourceLogoUrl = null;
        this.targetId = null;
        this.targetName = null;
        this.targetLogoUrl = null;
        this.amount = null;
        this.status = null;
    }
    setDataFromApi(data) {
        const response = Util.jsonParse(data)
        this.referenceQrId = response.data.referenceQrId;
        this.sourceId = response.data.sourceId;
        this.sourceName = response.data.sourceName;
        this.sourceLogoUrl = response.data.sourceLogoUrl;
        this.targetId = response.data.targetId;
        this.targetName = response.data.targetName;
        this.targetLogoUrl = response.data.targetLogoUrl;
        this.amount = response.data.amount;
        this.status = response.data.status;
        return this;
        
    }
}
